var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 15.7087C3.74199 15.7087 0.291992 12.2587 0.291992 8.00033C0.291992 3.74199 3.74199 0.291992 8.00033 0.291992C12.2587 0.291992 15.7087 3.74199 15.7087 8.00033C15.7087 12.2587 12.2587 15.7087 8.00033 15.7087Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57581 6.40039L6.42578 9.60039",
    stroke: "#646464",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42578 6.40039L9.57581 9.60039",
    stroke: "#646464",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.4cdb5dd60c4fe7ce64561c539cdb6982.svg";
export { ForwardRef as ReactComponent };